import "../../styles/campaign-agent.scss";
import { useState } from "react";
import axios from "axios";

export default function CampaignAgent() {
  const [messages, setMessages] = useState([
    { role: "system", content: "You are a helpful assistant." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    try {
      const res = await axios.post("http://localhost:4160/meta/chat", {
        messages: newMessages,
      });

      const assistantReply = res.data.response;

      setMessages([
        ...newMessages,
        { role: "assistant", content: assistantReply },
      ]);
    } catch (err) {
      console.error("AI Error:", err);
      setMessages([
        ...newMessages,
        { role: "assistant", content: "Sorry, something went wrong." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <div className="chat">
      <h1>COMING SOON</h1>
      {/* <div className="chat__window">
        {messages
          .filter((msg) => msg.role !== "system")
          .map((msg, idx) => (
            <div
              key={idx}
              className={`chat__bubble ${
                msg.role === "user" ? "chat__bubble--user" : "chat__bubble--ai"
              }`}
            >
              {msg.content}
            </div>
          ))}
      </div>

      <div className="chat__input">
        <input
          type="text"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleEnter}
          disabled={loading}
        />
        <button onClick={sendMessage} disabled={loading || !input.trim()}>
          {loading ? "Sending..." : "Send"}
        </button>
      </div> */}
    </div>
  );
}
